import { filterItemsEpic } from './state/filter-items.epic';
import { reloadEpic } from './state/reload.epic';
import { updateItemsEpic } from './state/update-items.epic';

export const eventCentreDialogEpics = [
    filterItemsEpic,
    reloadEpic,
    updateItemsEpic,
];
